// extracted by mini-css-extract-plugin
export default {"wrapper":"B1_w79h0FVINktqbQ4OP","account":"jQRHgeoA9hZ2nYG2ssTm","linkedResources":"OP6XGM5DEseMXXhW9jKQ","offboarding":"qM210HgadCPekFYrL7ON"};